import { Component, Input, Output, EventEmitter } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"

@Component({
    selector: "app-add-school-modal",
    templateUrl: "./add-school-modal.component.html",
    styleUrls: ["./add-school-modal.component.less"],
})
export class AddSchoolModalComponent {
    public isSubmitted: boolean = false

    @Input() public suggestedSchool: any
    @Output() public handler: EventEmitter<any> = new EventEmitter()

    constructor(public activeModal: ModalRef) {}

    public handleData(): void {
        if (this.suggestedSchool.name && this.suggestedSchool.zipCode) {
            this.handler.emit({
                school_name: this.suggestedSchool.name,
                school_address: this.suggestedSchool.address,
                school_city: this.suggestedSchool.city,
                school_zip: this.suggestedSchool.zipCode,
            })
            this.closeModal()

            this.isSubmitted = true
            this.suggestedSchool.name = ""
            this.suggestedSchool.zipCode = ""
            this.suggestedSchool.address = ""
            this.suggestedSchool.city = ""
        } else {
            this.isSubmitted = true
        }
    }

    public closeModal(): void {
        this.activeModal.dismiss()
    }
}
